export class OrderColumnWidthsSignedTab {
  uniqueTrackingNum: number = 0;
  deaLicenseId: number = 0;
  customerName: number = 0;
  purchaseOrderId: number = 0;
  account: number = 0;
  orderId: number = 0;
  lastUpdatedUser: number = 0;
  lastUpdatedTime: number = 0;
  [key: string]: number;
}
